import { defineStore } from 'pinia';

import * as state from './notification.state';
import * as getters from './notification.getters';
import * as actions from './notification.actions';

export const useNotificationStore = defineStore('notification', () => ({
  ...state,
  ...getters,
  ...actions
}));
